import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';

interface ILayoutSplitProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

const Layout = styled.div`
  position: relative;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
`;

const Section = styled.section`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 0 ${toRem(theme.space.xl)};

  @media (min-width: ${theme.breakpoint.med}px) {
    width: 50%;
    padding: 0 ${toRem(theme.space['3xl'])};
  }
`;

const Left = styled(Section)`
  background-color: ${theme.color.neutral[50]};
`;

const Right = styled(Section)`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  display: none;
  background-color: ${theme.color.neutral[800]};

  @media (min-width: ${theme.breakpoint.med}px) {
    display: flex;
  }
`;

const LayoutSplit: React.FC<ILayoutSplitProps> = ({ left, right, className, ...rest }) => (
  <Layout {...rest} className={className}>
    <Left>{left}</Left>
    <Right>{right}</Right>
  </Layout>
);

export default LayoutSplit;
